import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import ActionHistoryItemList from '@features/oneOnboardingAdmin/pages/NewCandidateProfilePage/CandidateInfo/ActionHistoryItemList/ActionHistoryItemList';
import { useGetUserActionHistory } from '@hooks/apiHooks';
import { useDecodedParams } from '@hooks/useDecodedParams';
import { UserRole } from '@models/user.model';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import { Box, Drawer, Grid, IconButton, Typography } from '@mui/material';
import { RootState } from '@store/rootReducer';

interface ActionHistoryProps {
  userId: any;
  isActive: boolean;
  onClose: () => void;
}

const configUserActionType = ['INTEGRATION_STATE_CHANGE', 'USER_FLOW_STEP_UPDATE', 'ONBOARDING_CUSTOM_DATA_CHANGE'];

const ActionHistory: FC<ActionHistoryProps> = ({ isActive, onClose, userId }) => {
  const { t } = useTranslation(['recruiter']);
  const tenantId = useSelector((state: RootState) => state.tenant.tenantId);
  const userRole = useSelector((state: RootState) => state.authAdmin.userRole);
  const { clientOrganizationId, applicationId, configurationId } = useDecodedParams();
  const { data, isLoading } = useGetUserActionHistory(
    tenantId,
    userId,
    applicationId,
    clientOrganizationId,
    configurationId,
  );

  const filteredData = data?.filter((item) => {
    return userRole === UserRole.adeccoConfig ? item : !configUserActionType.includes(item.actionType) && item;
  });

  return (
    <Drawer
      open={isActive}
      anchor="right"
      onClose={onClose}
      PaperProps={{
        sx: {
          backgroundColor: 'rgba(248, 248, 249, 1)',
          width: '470px',
        },
      }}
    >
      <Box className="admin" style={{ height: '100%' }} mb={4} ml={4} mt={4}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Typography variant="h3">{t('recruiter:GENERAL.CANDIDATE_DETAILS.actionHistory')}</Typography>
          <IconButton onClick={onClose}>
            <CloseRoundedIcon color="primary" />
          </IconButton>
        </Box>
        <Grid>
          <Box
            className="tag-ds"
            style={{ paddingTop: '20px', width: '100% !important' }}
            display="flex"
            justifyContent="space-between"
          />
        </Grid>
        <Grid>
          <ActionHistoryItemList data={filteredData} isLoading={isLoading} />
        </Grid>
      </Box>
    </Drawer>
  );
};

export default ActionHistory;
